function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { boxShadow } from "../../utils/css/cssFor";
import { DEPRECATED_VARIANTS_ENUM } from "./constants";
import { rgba } from "../../utils/styleUtils";
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
var resolvedAppearance = function(variant, appearance, isFAB, isElevated) {
    var filledToLinedVariants = [
        'neutral-black'
    ];
    var ghostAlwaysVariants = [
        'menu'
    ];
    if (isFAB || isElevated) {
        return 'filled';
    }
    if (filledToLinedVariants.some(function(v) {
        return v === variant;
    }) && appearance === 'filled') {
        return 'lined';
    }
    if (ghostAlwaysVariants.some(function(v) {
        return v === variant;
    })) {
        return 'ghost';
    }
    return appearance !== null && appearance !== void 0 ? appearance : 'filled';
};
var defaultAppearanceStates = {
    base: {},
    disabled: {},
    active: {}
};
var defaultVariantAppearances = {
    filled: _objectSpread({}, defaultAppearanceStates),
    lined: _objectSpread({}, defaultAppearanceStates),
    ghost: _objectSpread({}, defaultAppearanceStates),
    primary: _objectSpread({}, defaultAppearanceStates),
    secondary: _objectSpread({}, defaultAppearanceStates),
    tertiary: _objectSpread({}, defaultAppearanceStates)
};
var defaultVariants = {
    accent: _objectSpread({}, defaultVariantAppearances),
    danger: _objectSpread({}, defaultVariantAppearances),
    interactive: _objectSpread({}, defaultVariantAppearances),
    neutral: _objectSpread({}, defaultVariantAppearances),
    success: _objectSpread({}, defaultVariantAppearances),
    tertiary: _objectSpread({}, defaultVariantAppearances),
    warning: _objectSpread({}, defaultVariantAppearances),
    brand: _objectSpread({}, defaultVariantAppearances),
    'neutral-white': _objectSpread({}, defaultVariantAppearances),
    'neutral-black': _objectSpread({}, defaultVariantAppearances),
    menu: _objectSpread({}, defaultVariantAppearances)
};
var defaultIconVariantAppearances = {
    filled: {},
    lined: {},
    ghost: {},
    primary: {},
    secondary: {},
    tertiary: {}
};
var defaultIconVariants = {
    accent: _objectSpread({}, defaultIconVariantAppearances),
    danger: _objectSpread({}, defaultIconVariantAppearances),
    interactive: _objectSpread({}, defaultIconVariantAppearances),
    neutral: _objectSpread({}, defaultIconVariantAppearances),
    success: _objectSpread({}, defaultIconVariantAppearances),
    tertiary: _objectSpread({}, defaultIconVariantAppearances),
    warning: _objectSpread({}, defaultIconVariantAppearances),
    brand: _objectSpread({}, defaultIconVariantAppearances),
    'neutral-white': _objectSpread({}, defaultIconVariantAppearances),
    'neutral-black': _objectSpread({}, defaultIconVariantAppearances),
    menu: _objectSpread({}, defaultIconVariantAppearances)
};
var buildStyle = function(theme, param, param1) {
    var end = param.end, readingDirection = param.readingDirection, start = param.start, wrappingButtons = param1.wrappingButtons;
    var font = theme.font, backgroundColor = theme.backgroundColor, borderColor = theme.borderColor, size = theme.size, spacing = theme.spacing, depth = theme.depth, animation = theme.animation;
    var _obj, _obj1, _obj2, _obj3;
    return {
        button: {
            base: _objectSpread({}, readingDirection, (_obj = {
                alignItems: 'center',
                backgroundColor: 'transparent',
                border: "".concat(size.border.base, "px solid transparent"),
                borderRadius: size.border.radius.fiveX,
                boxSizing: 'border-box',
                cursor: 'pointer',
                display: 'inline-flex',
                fontFamily: font.base.family,
                fontStyle: 'normal',
                fontWeight: font.base.weight.regular
            }, _defineProperty(_obj, wrappingButtons ? 'minHeight' : 'height', 40), _defineProperty(_obj, "justifyContent", 'center'), _defineProperty(_obj, "letterSpacing", 0), _defineProperty(_obj, end.margin, 0), _defineProperty(_obj, start.margin, 0), _defineProperty(_obj, "maxWidth", '100%'), _defineProperty(_obj, "paddingBottom", 0), _defineProperty(_obj, "paddingTop", 0), _defineProperty(_obj, "textDecoration", 'none'), _defineProperty(_obj, "transition", "background-color ".concat(animation.expressive.easeOut.easing, " ").concat(animation.duration[100], ", color ").concat(animation.expressive.easeOut.easing, " ").concat(animation.duration[100], ", border-color ").concat(animation.expressive.easeOut.easing, " ").concat(animation.duration[100], ", box-shadow ").concat(animation.productive.easeInOut.easing, " ").concat(animation.duration[100])), _obj)),
            variant: _objectSpread({
                brand: _objectSpread({}, defaultVariantAppearances, {
                    filled: {
                        base: {
                            backgroundColor: backgroundColor.click.base,
                            color: font.color.fill,
                            '@media (hover: hover)': {
                                '&:hover': {
                                    backgroundColor: backgroundColor.click.hover
                                }
                            },
                            '&:active': {
                                backgroundColor: backgroundColor.click.active,
                                transform: animation.transform.shrink
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.brand.focus)
                            },
                            svg: {
                                fill: font.color.fill
                            }
                        },
                        disabled: {
                            backgroundColor: backgroundColor.click.disabled,
                            opacity: depth.opacity.light,
                            cursor: 'default',
                            '&:hover, &:active': {
                                backgroundColor: backgroundColor.click.disabled,
                                opacity: depth.opacity.light,
                                cursor: 'default',
                                boxShadow: 'none',
                                transform: 'none'
                            }
                        },
                        active: {
                            backgroundColor: backgroundColor.click.active,
                            svg: {
                                fill: font.color.fill
                            }
                        }
                    },
                    lined: {
                        base: {
                            backgroundColor: 'transparent',
                            color: font.color.brand.base,
                            border: "".concat(size.border.base, "px solid ").concat(borderColor.brand.base),
                            '@media (hover: hover)': {
                                '&:hover': {
                                    backgroundColor: backgroundColor.clickHard.hover,
                                    color: font.color.fill,
                                    svg: {
                                        fill: font.color.fill
                                    }
                                }
                            },
                            '&:active': {
                                backgroundColor: backgroundColor.clickHard.active,
                                color: font.color.fill,
                                transform: animation.transform.shrink,
                                svg: {
                                    fill: font.color.fill
                                }
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.brand.focus)
                            }
                        },
                        disabled: {
                            opacity: depth.opacity.light,
                            cursor: 'default',
                            '&:hover, &:active': {
                                backgroundColor: 'transparent',
                                color: font.color.brand.base,
                                border: "".concat(size.border.base, "px solid ").concat(borderColor.brand.base),
                                opacity: depth.opacity.light,
                                cursor: 'default',
                                transform: 'none',
                                svg: {
                                    fill: 'currentColor'
                                }
                            }
                        },
                        active: {
                            backgroundColor: backgroundColor.clickHard.active,
                            color: font.color.fill,
                            svg: {
                                fill: font.color.fill
                            }
                        }
                    },
                    ghost: {
                        base: {
                            backgroundColor: 'transparent',
                            color: font.color.brand.base,
                            '@media (hover: hover)': {
                                '&:hover': {
                                    backgroundColor: backgroundColor.clickSoft.hover,
                                    color: font.color.brand.hover,
                                    svg: {
                                        fill: font.color.brand.hover
                                    }
                                }
                            },
                            '&:active': {
                                backgroundColor: backgroundColor.clickSoft.active,
                                color: font.color.brand.hover,
                                transform: animation.transform.shrink,
                                svg: {
                                    fill: font.color.brand.hover
                                }
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.brand.focus)
                            }
                        },
                        disabled: {
                            opacity: depth.opacity.light,
                            cursor: 'default',
                            '&:hover, &:active': {
                                backgroundColor: 'transparent',
                                color: font.color.brand.base,
                                cursor: 'default',
                                transform: 'none',
                                svg: {
                                    fill: 'currentColor'
                                }
                            }
                        },
                        active: {
                            backgroundColor: backgroundColor.clickSoft.active,
                            color: font.color.brand.hover
                        }
                    }
                }),
                'neutral-white': _objectSpread({}, defaultVariantAppearances, {
                    filled: {
                        base: {
                            backgroundColor: backgroundColor.neutral.base,
                            color: font.color.base,
                            '@media (hover: hover)': {
                                '&:hover': {
                                    backgroundColor: backgroundColor.clickNeutral.surface
                                }
                            },
                            '&:active': {
                                backgroundColor: backgroundColor.active,
                                transform: animation.transform.shrink
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.interactive.focus)
                            },
                            svg: {
                                fill: font.color.base
                            }
                        },
                        disabled: {
                            opacity: depth.opacity.light,
                            cursor: 'default',
                            '&:hover, &:active': {
                                opacity: depth.opacity.light,
                                cursor: 'default',
                                boxShadow: 'none',
                                transform: 'none'
                            }
                        },
                        active: {
                            backgroundColor: backgroundColor.active,
                            svg: {
                                fill: font.color.base
                            }
                        }
                    },
                    lined: {
                        base: {
                            backgroundColor: 'transparent',
                            color: font.color.fill,
                            border: "".concat(size.border.base, "px solid ").concat(borderColor.neutral.fill.base),
                            '@media (hover: hover)': {
                                '&:hover': {
                                    backgroundColor: rgba(backgroundColor.neutral.fill.hover, depth.opacity.light)
                                }
                            },
                            '&:active': {
                                backgroundColor: rgba(backgroundColor.neutral.fill.active, depth.opacity.heavy),
                                transform: animation.transform.shrink
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.neutral.fill.focus)
                            }
                        },
                        disabled: {
                            opacity: depth.opacity.light,
                            cursor: 'default',
                            '&:hover, &:active': {
                                opacity: depth.opacity.light,
                                cursor: 'default',
                                transform: 'none'
                            }
                        },
                        active: {
                            backgroundColor: rgba(backgroundColor.neutral.fill.active, depth.opacity.heavy),
                            transform: animation.transform.shrink
                        }
                    },
                    ghost: {
                        base: {
                            backgroundColor: 'transparent',
                            color: font.color.neutral.fill,
                            '@media (hover: hover)': {
                                '&:hover': {
                                    backgroundColor: rgba(backgroundColor.neutral.fill.hover, depth.opacity.light)
                                }
                            },
                            '&:active': {
                                backgroundColor: rgba(backgroundColor.neutral.fill.active, depth.opacity.heavy),
                                transform: animation.transform.shrink
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.neutral.fill.focus)
                            }
                        },
                        disabled: {
                            opacity: depth.opacity.light,
                            cursor: 'default',
                            '&:hover, &:active': {
                                opacity: depth.opacity.light,
                                cursor: 'default'
                            }
                        },
                        active: {
                            backgroundColor: rgba(backgroundColor.neutral.fill.active, depth.opacity.heavy),
                            transform: animation.transform.shrink
                        }
                    }
                }),
                'neutral-black': _objectSpread({}, defaultVariantAppearances, {
                    lined: {
                        base: {
                            backgroundColor: 'transparent',
                            color: font.color.base,
                            border: "".concat(size.border.base, "px solid ").concat(borderColor.neutral.base),
                            '@media (hover: hover)': {
                                '&:hover': {
                                    backgroundColor: rgba(backgroundColor.clickNeutral.hover, depth.opacity.light)
                                }
                            },
                            '&:active': {
                                backgroundColor: rgba(backgroundColor.clickNeutral.active, depth.opacity.light),
                                transform: animation.transform.shrink
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.neutral.base)
                            }
                        },
                        disabled: {
                            opacity: depth.opacity.light,
                            cursor: 'default',
                            '&:hover, &:active': {
                                opacity: depth.opacity.light,
                                cursor: 'default',
                                backgroundColor: 'transparent'
                            }
                        },
                        active: {
                            backgroundColor: rgba(backgroundColor.clickNeutral.active, depth.opacity.light),
                            transform: animation.transform.shrink
                        }
                    },
                    ghost: {
                        base: {
                            backgroundColor: 'transparent',
                            color: font.color.base,
                            '@media (hover: hover)': {
                                '&:hover': {
                                    backgroundColor: rgba(backgroundColor.clickNeutral.hover, depth.opacity.light)
                                }
                            },
                            '&:active': {
                                backgroundColor: rgba(backgroundColor.clickNeutral.active, depth.opacity.light),
                                transform: animation.transform.shrink
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.neutral.base)
                            }
                        },
                        disabled: {
                            opacity: depth.opacity.light,
                            cursor: 'default',
                            '&:hover, &:active': {
                                opacity: depth.opacity.light,
                                cursor: 'default',
                                backgroundColor: 'transparent',
                                transform: 'unset'
                            }
                        },
                        active: {
                            backgroundColor: rgba(backgroundColor.neutral.active, depth.opacity.light),
                            transform: animation.transform.shrink
                        }
                    }
                }),
                menu: _objectSpread({}, defaultVariantAppearances, {
                    ghost: {
                        base: {
                            backgroundColor: 'transparent',
                            color: font.color.neutral.hover,
                            borderRadius: size.border.radius.round,
                            svg: {
                                fill: font.color.neutral.hover
                            },
                            '@media (hover: hover)': {
                                '&:hover': {
                                    backgroundColor: backgroundColor.selectList.hover
                                }
                            },
                            '&:active': {
                                color: font.color.brand.base,
                                backgroundColor: backgroundColor.selectList.active,
                                transform: animation.transform.shrink,
                                svg: {
                                    fill: font.color.brand.base
                                }
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.brand.focus)
                            }
                        },
                        disabled: {
                            opacity: depth.opacity.light,
                            cursor: 'default',
                            '&:hover, &:active': {
                                opacity: depth.opacity.light,
                                cursor: 'default',
                                backgroundColor: 'transparent',
                                transform: 'none',
                                svg: {
                                    fill: font.color.neutral.hover
                                }
                            }
                        },
                        active: {
                            color: font.color.brand.base,
                            backgroundColor: backgroundColor.selectList.active,
                            transform: animation.transform.shrink,
                            svg: {
                                fill: font.color.brand.base
                            }
                        }
                    }
                }),
                danger: _objectSpread({}, defaultVariantAppearances, {
                    filled: {
                        base: {
                            color: font.color.danger.fill,
                            backgroundColor: backgroundColor.danger.fill.base,
                            borderColor: borderColor.danger.base,
                            '@media (hover: hover)': {
                                '&:hover': {
                                    color: font.color.danger.fill,
                                    backgroundColor: backgroundColor.danger.fill.hover,
                                    borderColor: borderColor.danger.hover
                                }
                            },
                            '&:active': {
                                color: font.color.danger.fill,
                                backgroundColor: backgroundColor.danger.fill.active,
                                borderColor: borderColor.danger.active,
                                transform: animation.transform.shrink
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.danger.focus)
                            }
                        },
                        disabled: {
                            backgroundColor: backgroundColor.neutral.fill.disabled,
                            borderColor: borderColor.danger.disabled
                        },
                        active: {
                            color: font.color.danger.fill,
                            backgroundColor: backgroundColor.danger.fill.active,
                            borderColor: borderColor.danger.active,
                            transform: animation.transform.shrink
                        }
                    },
                    lined: {
                        base: {
                            color: font.color.danger.base,
                            borderColor: borderColor.danger.base,
                            '@media (hover: hover)': {
                                '&:hover': {
                                    color: font.color.danger.fill,
                                    backgroundColor: backgroundColor.danger.fill.hover,
                                    borderColor: borderColor.danger.hover
                                }
                            },
                            '&:active': {
                                color: font.color.danger.fill,
                                backgroundColor: backgroundColor.danger.fill.active,
                                borderColor: borderColor.danger.active,
                                transform: animation.transform.shrink
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.danger.focus)
                            }
                        },
                        disabled: {
                            borderColor: borderColor.danger.disabled,
                            color: font.color.danger.disabled
                        },
                        active: {
                            color: font.color.danger.fill,
                            backgroundColor: backgroundColor.danger.fill.active,
                            borderColor: borderColor.danger.active
                        }
                    },
                    ghost: {
                        base: {
                            color: font.color.danger.base,
                            borderColor: 'transparent',
                            '@media (hover: hover)': {
                                '&:hover': {
                                    color: font.color.danger.fill,
                                    backgroundColor: backgroundColor.danger.fill.hover,
                                    borderColor: borderColor.danger.hover
                                }
                            },
                            '&:active': {
                                color: font.color.danger.fill,
                                backgroundColor: backgroundColor.danger.fill.active,
                                borderColor: borderColor.danger.active,
                                transform: animation.transform.shrink,
                                svg: {
                                    fill: font.color.danger.fill
                                }
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.danger.focus)
                            }
                        },
                        disabled: {
                            color: font.color.danger.disabled
                        },
                        active: {
                            color: font.color.danger.fill,
                            backgroundColor: backgroundColor.danger.fill.active,
                            borderColor: borderColor.danger.active
                        }
                    }
                })
            }, DEPRECATED_VARIANTS_ENUM.reduce(function(acc, variant) {
                return _objectSpread({}, acc, _defineProperty({}, variant, _objectSpread({}, defaultVariantAppearances, {
                    filled: {
                        base: {
                            color: font.color[variant].fill,
                            backgroundColor: backgroundColor[variant].fill.base,
                            borderColor: borderColor[variant].base,
                            '@media (hover: hover)': {
                                '&:hover': {
                                    color: font.color[variant].fill,
                                    backgroundColor: backgroundColor[variant].fill.hover,
                                    borderColor: borderColor[variant].hover
                                }
                            },
                            '&:active': {
                                color: font.color[variant].fill,
                                backgroundColor: backgroundColor[variant].fill.active,
                                borderColor: borderColor[variant].active
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor[variant].focus)
                            }
                        },
                        disabled: {
                            backgroundColor: backgroundColor.neutral.fill.disabled,
                            borderColor: borderColor[variant].disabled
                        },
                        active: {
                            color: font.color[variant].fill,
                            backgroundColor: backgroundColor[variant].fill.active,
                            borderColor: borderColor[variant].active,
                            transform: animation.transform.shrink
                        }
                    },
                    lined: {
                        base: {
                            color: font.color[variant].base,
                            borderColor: borderColor[variant].base,
                            '@media (hover: hover)': {
                                '&:hover': {
                                    color: font.color[variant].fill,
                                    backgroundColor: backgroundColor[variant].fill.hover,
                                    borderColor: borderColor[variant].hover
                                }
                            },
                            '&:active': {
                                color: font.color[variant].fill,
                                backgroundColor: backgroundColor[variant].fill.active,
                                borderColor: borderColor[variant].active,
                                transform: animation.transform.shrink
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor[variant].focus)
                            }
                        },
                        disabled: {
                            borderColor: borderColor[variant].disabled,
                            color: font.color[variant].disabled
                        },
                        active: {
                            color: font.color[variant].fill,
                            backgroundColor: backgroundColor[variant].fill.active,
                            borderColor: borderColor[variant].active
                        }
                    },
                    ghost: {
                        base: {
                            color: font.color[variant].base,
                            borderColor: 'transparent',
                            '@media (hover: hover)': {
                                '&:hover': {
                                    color: font.color[variant].fill,
                                    backgroundColor: backgroundColor[variant].fill.hover,
                                    borderColor: borderColor[variant].hover
                                }
                            },
                            '&:active': {
                                color: font.color[variant].fill,
                                backgroundColor: backgroundColor[variant].fill.active,
                                borderColor: borderColor[variant].active,
                                transform: animation.transform.shrink,
                                svg: {
                                    fill: font.color[variant].fill
                                }
                            },
                            '&:focus-visible': {
                                outline: 'none',
                                boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor[variant].focus)
                            }
                        },
                        disabled: {
                            color: font.color[variant].disabled
                        },
                        active: {
                            color: font.color[variant].fill,
                            backgroundColor: backgroundColor[variant].fill.active,
                            borderColor: borderColor[variant].active
                        }
                    }
                })));
            }, {})),
            elevated: {
                '@media (hover: hover)': {
                    '&:hover': _objectSpread({}, boxShadow(4, theme), {
                        transform: animation.transform.grow,
                        backgroundColor: backgroundColor.brand.fill.hover
                    })
                },
                '&:active': {
                    transform: 'unset',
                    backgroundColor: backgroundColor.brand.fill.active
                }
            },
            pill: {
                borderRadius: size.border.radius.round
            },
            block: {
                width: '100%'
            },
            size: {
                s: (_obj1 = {
                    fontSize: font.base.size['3']
                }, _defineProperty(_obj1, start.padding, spacing['5']), _defineProperty(_obj1, end.padding, spacing['5']), _defineProperty(_obj1, "minWidth", 80), _defineProperty(_obj1, wrappingButtons ? 'minHeight' : 'height', 36), _obj1),
                m: (_obj2 = {
                    fontSize: font.base.size['4']
                }, _defineProperty(_obj2, start.padding, spacing['6']), _defineProperty(_obj2, end.padding, spacing['6']), _defineProperty(_obj2, "minWidth", 96), _defineProperty(_obj2, wrappingButtons ? 'minHeight' : 'height', 40), _obj2),
                l: (_obj3 = {
                    fontSize: font.base.size['4']
                }, _defineProperty(_obj3, start.padding, spacing['6']), _defineProperty(_obj3, end.padding, spacing['6']), _defineProperty(_obj3, "minWidth", 112), _defineProperty(_obj3, wrappingButtons ? 'minHeight' : 'height', 44), _obj3)
            }
        },
        icon: {
            base: {
                size: {
                    s: {
                        padding: spacing['2'],
                        height: 36,
                        width: 36,
                        minWidth: 0
                    },
                    m: {
                        padding: spacing['3'],
                        height: 40,
                        width: 40,
                        minWidth: 0
                    },
                    l: {
                        padding: spacing['3'],
                        height: 44,
                        width: 44,
                        minWidth: 0
                    },
                    fab: _objectSpread({
                        borderRadius: size.border.radius.round,
                        padding: 12,
                        height: 64,
                        width: 64,
                        minWidth: 0
                    }, boxShadow(4, theme), {
                        '@media (hover: hover)': {
                            '&:hover': _objectSpread({}, boxShadow(4, theme), {
                                backgroundColor: backgroundColor.brand.fill.hover
                            })
                        },
                        '&:active': _objectSpread({}, boxShadow(2, theme), {
                            transform: animation.transform.shrink,
                            backgroundColor: backgroundColor.brand.fill.active
                        }),
                        '.js-focus-visible &:focus': {
                            boxShadow: "".concat(boxShadow(4, theme).boxShadow, ", 0 0 0 ").concat(size.border.focus, "px ").concat(borderColor.brand.focus)
                        }
                    })
                }
            },
            styles: {
                variant: _objectSpread({}, defaultIconVariants, {
                    brand: _objectSpread({}, defaultIconVariantAppearances, {
                        filled: {
                            color: font.color.fill
                        },
                        lined: {
                            color: font.color.brand.base
                        },
                        ghost: {
                            color: font.color.brand.base
                        }
                    }),
                    'neutral-white': _objectSpread({}, defaultIconVariantAppearances, {
                        lined: {
                            color: font.color.fill
                        },
                        ghost: {
                            color: font.color.fill
                        }
                    }),
                    'neutral-black': _objectSpread({}, defaultIconVariantAppearances, {
                        lined: {
                            color: font.color.neutral.hover
                        },
                        ghost: {
                            color: font.color.neutral.hover
                        }
                    }),
                    menu: _objectSpread({}, defaultIconVariantAppearances, {
                        ghost: {}
                    })
                }),
                s: {
                    size: 'm'
                },
                m: {
                    size: 'm'
                },
                l: {
                    size: 'm'
                },
                fab: {
                    size: 'l'
                }
            },
            withText: {
                s: {
                    size: 's'
                },
                m: {
                    size: 's'
                },
                l: {
                    size: 's'
                }
            }
        }
    };
};
var useStyle = function(param) {
    var appearance = param.appearance, variant = param.variant, isPill = param.isPill, isBlock = param.isBlock, iconOnly = param.iconOnly, isRtl = param.isRtl, isElevated = param.isElevated, isFAB = param.isFAB, active = param.active, isDisabled = param.isDisabled, size = param.size, iconSize = param.iconSize;
    var style = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!(style === null || style === void 0 ? void 0 : style.button)) {
        return {
            buttonStyles: {},
            iconStyles: {}
        };
    }
    var button = style.button, icon = style.icon;
    var _variant = variant && !isFAB && !isElevated ? variant : 'brand';
    var _size = size !== null && size !== void 0 ? size : 'm';
    var _appearance = resolvedAppearance(_variant, appearance, isFAB, isElevated);
    return {
        buttonStyles: _objectSpread({}, button.base, button.variant[_variant][_appearance].base, isDisabled && button.variant[_variant][_appearance].disabled, active && button.variant[_variant][_appearance].active, isPill && button.pill, button.size[_size], iconOnly && icon.base.size[_size], isBlock && button.block, isFAB && icon.base.size.fab, isElevated && button.elevated),
        iconStyles: _objectSpread({}, icon.styles.variant[_variant][_appearance], iconOnly ? icon.styles[_size] : icon.withText[_size], isFAB && icon.styles.fab, iconSize && {
            size: iconSize
        })
    };
};
export default useStyle;
